'use client';

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@/comps/primitives/skeleton';
import { AI_SPEND_KPI_GRID_CLASS, AVG_SPEND_PER_TASK_CARD_TOOLTIP, AVG_SPEND_PER_TASK_VISUAL_BLOCK_HEIGHT_PX, SPEND_BY_MODEL_CARD_TITLE, SPEND_BY_MODEL_CARD_TOOLTIP, SPEND_BY_MODEL_CHART_MIN_HEIGHT_CLASS, SPEND_DISTRIBUTION_CARD_TITLE, SPEND_DISTRIBUTION_CARD_TOOLTIP, SPEND_DISTRIBUTION_SECTION_LOADING_HEIGHT_PX, SPEND_KPI_VALUE_ROW_HEIGHT_PX, SPEND_OVER_TIME_CARD_TITLE, SPEND_OVER_TIME_CARD_TOOLTIP, SPEND_OVER_TIME_CHART_MIN_HEIGHT_CLASS, TOTAL_AI_SPEND_CARD_TOOLTIP } from '@/domains/pages/ai-spend/constants';
import { NebulyPageCard } from '@/domains/pages/shared/nebuly-page-card';
import { cn } from '@/utils/shad';
const KPI_VALUE_SKELETON_CLASS = 'w-30';
function KpiStackSkeleton() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <NebulyPageCard title="Total AI spend" description={TOTAL_AI_SPEND_CARD_TOOLTIP} className="grow-0 border-b border-b-lightborder" contentClassName="flex flex-col gap-3 !py-3"><Skeleton className={KPI_VALUE_SKELETON_CLASS} style={{
        height: SPEND_KPI_VALUE_ROW_HEIGHT_PX
      }} /></NebulyPageCard>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex min-w-0 flex-col border-r border-r-lightborder">{t0}<NebulyPageCard title="Avg. AI spend per task" description={AVG_SPEND_PER_TASK_CARD_TOOLTIP} className="grow-0" contentClassName="flex flex-col gap-3 !py-3"><Skeleton className={KPI_VALUE_SKELETON_CLASS} style={{
          height: SPEND_KPI_VALUE_ROW_HEIGHT_PX
        }} /><div style={{
          height: AVG_SPEND_PER_TASK_VISUAL_BLOCK_HEIGHT_PX
        }} /></NebulyPageCard></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function OverTimeChartSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex h-full min-w-0"><NebulyPageCard title={SPEND_OVER_TIME_CARD_TITLE} description={SPEND_OVER_TIME_CARD_TOOLTIP} fillHeight={true} className="min-h-0 flex-1" contentClassName="flex min-h-0 flex-1 flex-col"><div className={cn("w-full flex-1", SPEND_OVER_TIME_CHART_MIN_HEIGHT_CLASS)} /></NebulyPageCard></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function TaskModelSectionSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <NebulyPageCard title={SPEND_BY_MODEL_CARD_TITLE} description={SPEND_BY_MODEL_CARD_TOOLTIP} className="min-h-0" contentClassName="flex flex-col gap-4 !py-4"><div className={cn("w-full", SPEND_BY_MODEL_CHART_MIN_HEIGHT_CLASS)} /></NebulyPageCard>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function DistributionSectionSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <NebulyPageCard title={SPEND_DISTRIBUTION_CARD_TITLE} description={SPEND_DISTRIBUTION_CARD_TOOLTIP} className="min-h-0" contentClassName="flex flex-col gap-4 !py-4"><div className="w-full" style={{
        height: SPEND_DISTRIBUTION_SECTION_LOADING_HEIGHT_PX
      }} /></NebulyPageCard>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export function AiSpendPageLoadingSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="border-b border-b-lightborder" data-testid="nebuly-page-loading"><div className={cn(AI_SPEND_KPI_GRID_CLASS, "items-stretch border-b border-b-lightborder")}><KpiStackSkeleton /><OverTimeChartSkeleton /></div><DistributionSectionSkeleton /><TaskModelSectionSkeleton /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}